module.exports = __webpack_public_path__ + "d0a2424ddcdcbdea64b8287fccb2fa50.svg";